import type { DefaultTranslationsObject, Language } from '../types.js'

export const faTranslations: DefaultTranslationsObject = {
  authentication: {
    account: 'حساب کاربری',
    accountOfCurrentUser: 'حساب کاربری فعلی',
    accountVerified: 'حساب شما با موفقیت تأیید شد.',
    alreadyActivated: 'این حساب قبلاً فعال شده است.',
    alreadyLoggedIn: 'شما در حال حاضر وارد شده‌اید.',
    apiKey: 'کلید API',
    authenticated: 'احراز هویت شده',
    backToLogin: 'بازگشت به صفحه ورود',
    beginCreateFirstUser: 'برای شروع، اولین کاربر را ایجاد کنید.',
    changePassword: 'تغییر رمز عبور',
    checkYourEmailForPasswordReset:
      'ایمیلی حاوی لینک بازنشانی رمز عبور برای شما ارسال شد. لطفاً پوشه اسپم (spam) خود را نیز بررسی کنید.',
    confirmGeneration: 'تأیید تولید',
    confirmPassword: 'تکرار رمز عبور',
    createFirstUser: 'ایجاد اولین کاربر',
    emailNotValid: 'ایمیل وارد شده معتبر نیست.',
    emailOrUsername: 'ایمیل یا نام کاربری',
    emailSent: 'ایمیل ارسال شد.',
    emailVerified: 'ایمیل با موفقیت تأیید شد.',
    enableAPIKey: 'فعال‌سازی کلید API',
    failedToUnlock: 'باز کردن قفل ناموفق بود.',
    forceUnlock: 'باز کردن اجباری قفل',
    forgotPassword: 'فراموشی رمز عبور',
    forgotPasswordEmailInstructions:
      'لطفاً ایمیل خود را وارد کنید. لینکی برای بازنشانی رمز عبور دریافت خواهید کرد.',
    forgotPasswordQuestion: 'رمز عبور خود را فراموش کرده‌اید؟',
    forgotPasswordUsernameInstructions:
      'لطفاً نام کاربری خود را وارد کنید. دستورالعمل بازنشانی رمز عبور به ایمیل مرتبط با حساب شما ارسال خواهد شد.',
    generate: 'تولید',
    generateNewAPIKey: 'تولید کلید API جدید',
    generatingNewAPIKeyWillInvalidate:
      'با تولید کلید جدید، کلید API فعلی شما <1>باطل</1> خواهد شد. آیا می‌خواهید ادامه دهید؟',
    lockUntil: 'قفل تا تاریخ',
    logBackIn: 'دوباره وارد شوید',
    loggedIn: 'برای ورود با یک حساب دیگر، ابتدا باید <0>خارج</0> شوید.',
    loggedInChangePassword: 'برای تغییر رمز عبور، به صفحه <0>حساب کاربری</0> خود مراجعه کنید.',
    loggedOutInactivity: 'به دلیل عدم فعالیت، از حساب خود خارج شدید.',
    loggedOutSuccessfully: 'شما با موفقیت خارج شدید.',
    loggingOut: 'در حال خروج...',
    login: 'ورود',
    loginAttempts: 'تلاش‌های ورود ناموفق',
    loginUser: 'ورود کاربر',
    loginWithAnotherUser: 'برای ورود با یک حساب دیگر، ابتدا باید <0>خارج</0> شوید.',
    logOut: 'خروج',
    logout: 'خروج',
    logoutSuccessful: 'خروج با موفقیت انجام شد.',
    logoutUser: 'خروج کاربر',
    newAccountCreated:
      'یک حساب کاربری جدید برای شما در <a href="{{serverURL}}">{{serverURL}}</a> ایجاد شد. لطفاً برای تأیید ایمیل خود روی لینک زیر کلیک کنید: <a href="{{verificationURL}}">{{verificationURL}}</a><br> پس از تأیید، می‌توانید وارد شوید.',
    newAPIKeyGenerated: 'کلید API جدید با موفقیت تولید شد.',
    newPassword: 'رمز عبور جدید',
    passed: 'تأیید شد',
    passwordResetSuccessfully: 'رمز عبور با موفقیت تغییر کرد.',
    resetPassword: 'بازنشانی رمز عبور',
    resetPasswordExpiration: 'انقضای توکن بازنشانی',
    resetPasswordToken: 'توکن بازنشانی رمز عبور',
    resetYourPassword: 'رمز عبور خود را بازنشانی کنید',
    stayLoggedIn: 'بله، آنلاین بمان',
    successfullyRegisteredFirstUser: 'اولین کاربر با موفقیت ثبت شد.',
    successfullyUnlocked: 'قفل حساب با موفقیت باز شد.',
    tokenRefreshSuccessful: 'توکن با موفقیت به‌روزرسانی شد.',
    unableToVerify: 'تأیید حساب امکان‌پذیر نیست.',
    username: 'نام کاربری',
    usernameNotValid: 'نام کاربری وارد شده معتبر نیست.',
    verified: 'تأیید شده',
    verifiedSuccessfully: 'با موفقیت تأیید شد.',
    verify: 'تأیید',
    verifyUser: 'تأیید کاربر',
    verifyYourEmail: 'ایمیل خود را تأیید کنید',
    youAreInactive:
      'شما برای مدتی غیرفعال بوده‌اید. برای امنیت، به‌زودی از حساب خود خارج می‌شوید. هنوز اینجا هستید؟',
    youAreReceivingResetPassword:
      'شما (یا شخص دیگری) درخواستی برای بازنشانی رمز عبور این حساب ارسال کرده‌اید. اگر این درخواست از طرف شما بوده، لطفاً روی لینک زیر کلیک کنید تا فرآیند را تکمیل کنید. در غیر این صورت، این ایمیل را نادیده بگیرید.',
    youDidNotRequestPassword:
      'اگر شما درخواست بازنشانی رمز عبور نداده‌اید، این ایمیل را نادیده بگیرید. رمز عبور شما تغییری نخواهد کرد.',
  },
  error: {
    accountAlreadyActivated: 'این حساب کاربری قبلاً فعال شده است.',
    autosaving: 'هنگام ذخیره خودکار این صفحه، خطایی رخ داد.',
    correctInvalidFields: 'لطفاً فیلدهای نامعتبر را اصلاح کنید.',
    deletingFile: 'هنگام حذف این فایل خطایی رخ داد.',
    deletingTitle: 'در حذف "{{title}}" خطایی رخ داد. لطفاً اتصال اینترنت خود را بررسی کنید.',
    documentNotFound:
      'صفحهی با شناسه {{id}} پیدا نشد. ممکن است حذف شده باشد یا شما اجازه دسترسی به آن را نداشته باشید.',
    emailOrPasswordIncorrect: 'ایمیل یا رمز عبور اشتباه است.',
    followingFieldsInvalid_one: 'فیلد زیر نامعتبر است:',
    followingFieldsInvalid_other: 'فیلدهای زیر نامعتبر هستند:',
    incorrectCollection: 'مجموعه (Collection) نامعتبر است.',
    insufficientClipboardPermissions:
      'دسترسی به کلیپ‌بورد امکان‌پذیر نیست. لطفاً دسترسی‌های مرورگر خود را بررسی کنید.',
    invalidClipboardData: 'اطلاعات نامعتبری در کلیپ‌بورد وجود دارد.',
    invalidFileType: 'نوع فایل انتخاب شده معتبر نیست.',
    invalidFileTypeValue: 'نوع فایل نامعتبر: {{value}}',
    invalidRequestArgs: 'آرگومان‌های نامعتبری در درخواست ارسال شد: {{args}}',
    loadingDocument: 'در بارگذاری صفحه با شناسه {{id}} مشکلی پیش آمد.',
    localesNotSaved_one: 'امکان ذخیره زبان زیر وجود ندارد:',
    localesNotSaved_other: 'امکان ذخیره زبان‌های زیر وجود ندارد:',
    logoutFailed: 'خروج از حساب کاربری ناموفق بود.',
    missingEmail: 'لطفاً ایمیل خود را وارد کنید.',
    missingIDOfDocument: 'شناسه صفحه برای به‌روزرسانی مشخص نشده است.',
    missingIDOfVersion: 'شناسه نسخه مشخص نشده است.',
    missingRequiredData: 'اطلاعات مورد نیاز ارسال نشده است.',
    noFilesUploaded: 'هیچ فایلی آپلود نشده است.',
    noMatchedField: 'فیلدی با عنوان "{{label}}" پیدا نشد.',
    notAllowedToAccessPage: 'شما اجازه دسترسی به این صفحه را ندارید.',
    notAllowedToPerformAction: 'شما مجاز به انجام این کار نیستید.',
    notFound: 'صفحه مورد نظر پیدا نشد.',
    noUser: 'کاربری یافت نشد.',
    previewing: 'هنگام نمایش پیش‌نمایش این فایل، خطایی رخ داد.',
    problemUploadingFile: 'هنگام آپلود فایل خطایی رخ داد.',
    restoringTitle:
      'در بازیابی "{{title}}" خطایی رخ داد. لطفاً اتصال اینترنت خود را بررسی کرده و دوباره تلاش کنید.',
    tokenInvalidOrExpired: 'توکن شما نامعتبر یا منقضی شده است.',
    tokenNotProvided: 'توکن ارسال نشده است.',
    unableToCopy: 'امکان کپی کردن وجود ندارد.',
    unableToDeleteCount: 'حذف {{count}} از {{total}} {{label}} امکان‌پذیر نیست.',
    unableToReindexCollection: 'خطا در بازسازی ایندکس مجموعه {{collection}}. عملیات متوقف شد.',
    unableToUpdateCount: 'به‌روزرسانی {{count}} از {{total}} {{label}} امکان‌پذیر نیست.',
    unauthorized: 'برای ارسال این درخواست، باید ابتدا وارد حساب کاربری خود شوید.',
    unauthorizedAdmin: 'شما اجازه دسترسی به پنل مدیریت را ندارید.',
    unknown: 'یک خطای ناشناخته رخ داد.',
    unPublishingDocument: 'هنگام لغو انتشار این صفحه، خطایی رخ داد.',
    unspecific: 'یک خطا رخ داد. لطفاً دوباره تلاش کنید.',
    unverifiedEmail: 'لطفاً قبل از ورود، ایمیل حساب کاربری خود را تأیید کنید.',
    userEmailAlreadyRegistered: 'کاربری با این ایمیل قبلاً ثبت‌نام کرده است.',
    userLocked: 'این حساب به دلیل تلاش‌های ناموفق متعدد برای ورود، قفل شده است.',
    usernameAlreadyRegistered: 'کاربری با این نام کاربری قبلاً ثبت‌نام کرده است.',
    usernameOrPasswordIncorrect: 'نام کاربری یا رمز عبور اشتباه است.',
    valueMustBeUnique: 'این مقدار باید منحصر به فرد باشد.',
    verificationTokenInvalid: 'توکن تأیید نامعتبر است.',
  },
  fields: {
    addLabel: 'افزودن {{label}}',
    addLink: 'افزودن لینک',
    addNew: 'افزودن مورد جدید',
    addNewLabel: 'افزودن {{label}} جدید',
    addRelationship: 'افزودن ارتباط',
    addUpload: 'افزودن فایل',
    block: 'بلاک',
    blocks: 'بلاک‌ها',
    blockType: 'نوع بلاک',
    chooseBetweenCustomTextOrDocument: 'یک URL سفارشی وارد کنید یا به یک صفحه دیگر لینک دهید.',
    chooseDocumentToLink: 'یک صفحه را برای لینک دادن انتخاب کنید',
    chooseFromExisting: 'انتخاب از موارد موجود',
    chooseLabel: 'انتخاب {{label}}',
    collapseAll: 'بستن همه',
    customURL: 'URL سفارشی',
    editLabelData: 'ویرایش اطلاعات {{label}}',
    editLink: 'ویرایش لینک',
    editRelationship: 'ویرایش ارتباط',
    enterURL: 'یک URL وارد کنید',
    internalLink: 'لینک داخلی',
    itemsAndMore: '{{items}} و {{count}} مورد دیگر',
    labelRelationship: 'ارتباط {{label}}',
    latitude: 'عرض جغرافیایی',
    linkedTo: 'لینک شده به <0>{{label}}</0>',
    linkType: 'نوع لینک',
    longitude: 'طول جغرافیایی',
    newLabel: '{{label}} جدید',
    openInNewTab: 'باز کردن در تب جدید',
    passwordsDoNotMatch: 'رمزهای عبور یکسان نیستند.',
    relatedDocument: 'صفحه مرتبط',
    relationTo: 'مرتبط با',
    removeRelationship: 'حذف ارتباط',
    removeUpload: 'حذف فایل',
    saveChanges: 'ذخیره تغییرات',
    searchForBlock: 'جستجو برای بلاک',
    searchForLanguage: 'جستجو برای یک زبان',
    selectExistingLabel: 'انتخاب {{label}} موجود',
    selectFieldsToEdit: 'فیلدهای مورد نظر برای ویرایش را انتخاب کنید',
    showAll: 'نمایش همه',
    swapRelationship: 'جابجایی ارتباط',
    swapUpload: 'جابجایی فایل',
    textToDisplay: 'متن نمایشی',
    toggleBlock: 'تغییر وضعیت بلاک',
    uploadNewLabel: 'آپلود {{label}} جدید',
  },
  folder: {
    browseByFolder: 'مرور بر اساس پوشه',
    byFolder: 'بر اساس پوشه',
    deleteFolder: 'حذف پوشه',
    folderName: 'نام پوشه',
    folders: 'پوشه‌ها',
    folderTypeDescription: 'انتخاب کنید چه نوع اسنادی می‌توانند در این پوشه قرار بگیرند.',
    itemHasBeenMoved: '"{{title}}" به پوشه "{{folderName}}" منتقل شد.',
    itemHasBeenMovedToRoot: '"{{title}}" به پوشه اصلی منتقل شد.',
    itemsMovedToFolder: '{{count}} مورد به پوشه "{{folderName}}" منتقل شد.',
    itemsMovedToRoot: '{{count}} مورد به پوشه اصلی منتقل شد.',
    moveFolder: 'انتقال پوشه',
    moveItemsToFolderConfirmation:
      'آیا از انتقال <1>{{count}} {{label}}</1> به پوشه <2>{{toFolder}}</2> مطمئن هستید؟',
    moveItemsToRootConfirmation:
      'آیا از انتقال <1>{{count}} {{label}}</1> به پوشه اصلی مطمئن هستید؟',
    moveItemToFolderConfirmation:
      'آیا از انتقال <1>{{title}}</1> به پوشه <2>{{toFolder}}</2> مطمئن هستید؟',
    moveItemToRootConfirmation: 'آیا از انتقال <1>{{title}}</1> به پوشه اصلی مطمئن هستید؟',
    movingFromFolder: 'انتقال "{{title}}" از پوشه {{fromFolder}}',
    newFolder: 'پوشه جدید',
    noFolder: 'بدون پوشه',
    renameFolder: 'تغییر نام پوشه',
    searchByNameInFolder: 'جستجو بر اساس نام در "{{folderName}}"',
    selectFolderForItem: 'انتخاب پوشه برای "{{title}}"',
  },
  general: {
    name: 'نام',
    aboutToDelete: 'آیا از حذف {{label}} "{{title}}" مطمئن هستید؟',
    aboutToDeleteCount_many: 'آیا از حذف {{count}} {{label}} مطمئن هستید؟',
    aboutToDeleteCount_one: 'آیا از حذف {{count}} {{label}} مطمئن هستید؟',
    aboutToDeleteCount_other: 'آیا از حذف {{count}} {{label}} مطمئن هستید؟',
    aboutToPermanentlyDelete:
      'شما در حال حذف دائمی {{label}} "{{title}}" هستید. این عمل قابل بازگشت نیست. آیا مطمئن هستید؟',
    aboutToPermanentlyDeleteTrash:
      'آیا از حذف دائمی <0>{{count}}</0> <1>{{label}}</1> از سطل زباله مطمئن هستید؟ این عمل قابل بازگشت نیست.',
    aboutToRestore: 'آیا از بازیابی {{label}} "{{title}}" مطمئن هستید؟',
    aboutToRestoreAsDraft: 'آیا می‌خواهید {{label}} "{{title}}" به عنوان پیش‌نویس بازیابی شود؟',
    aboutToRestoreAsDraftCount: 'آیا می‌خواهید {{count}} {{label}} به عنوان پیش‌نویس بازیابی شوند؟',
    aboutToRestoreCount: 'آیا از بازیابی {{count}} {{label}} مطمئن هستید؟',
    aboutToTrash: 'آیا می‌خواهید {{label}} "{{title}}" به سطل زباله منتقل شود؟',
    aboutToTrashCount: 'آیا می‌خواهید {{count}} {{label}} به سطل زباله منتقل شوند؟',
    addBelow: 'افزودن در زیر',
    addFilter: 'افزودن فیلتر',
    adminTheme: 'پوسته پنل مدیریت',
    all: 'همه',
    allCollections: 'همه مجموعه‌ها',
    allLocales: 'همه زبان‌ها',
    and: 'و',
    anotherUser: 'کاربر دیگر',
    anotherUserTakenOver: 'کاربر دیگری ویرایش این صفحه را در دست گرفته است.',
    applyChanges: 'اعمال تغییرات',
    ascending: 'صعودی',
    automatic: 'خودکار',
    backToDashboard: 'بازگشت به داشبورد',
    cancel: 'انصراف',
    changesNotSaved:
      'تغییرات شما ذخیره نشده‌اند. در صورت خروج از این صفحه، این تغییرات از بین خواهند رفت.',
    clear: 'پاک کردن',
    clearAll: 'پاک کردن همه',
    close: 'بستن',
    collapse: 'بستن',
    collections: 'مجموعه‌ها',
    columns: 'ستون‌ها',
    columnToSort: 'ستون برای مرتب‌سازی',
    confirm: 'تأیید',
    confirmCopy: 'تأیید کپی',
    confirmDeletion: 'تأیید حذف',
    confirmDuplication: 'تأیید ایجاد کپی',
    confirmMove: 'تأیید انتقال',
    confirmReindex: 'آیا همه {{collections}} دوباره ایندکس شوند؟',
    confirmReindexAll: 'آیا همه مجموعه‌ها دوباره ایندکس شوند؟',
    confirmReindexDescription:
      'این کار ایندکس‌های موجود را حذف کرده و اسناد را در مجموعه‌های {{collections}} دوباره ایندکس می‌کند.',
    confirmReindexDescriptionAll:
      'این کار ایندکس‌های موجود را حذف کرده و اسناد را در همه مجموعه‌ها دوباره ایندکس می‌کند.',
    confirmRestoration: 'تأیید بازیابی',
    copied: 'کپی شد',
    copy: 'کپی',
    copyField: 'کپی کردن فیلد',
    copying: 'در حال کپی...',
    copyRow: 'کپی کردن ردیف',
    copyWarning:
      'شما در حال کپی کردن مقادیر از {{from}} به {{to}} برای {{label}} "{{title}}" هستید. آیا مطمئن هستید؟',
    create: 'ایجاد',
    created: 'ایجاد شد',
    createdAt: 'تاریخ ایجاد',
    createNew: 'ایجاد مورد جدید',
    createNewLabel: 'ایجاد {{label}} جدید',
    creating: 'در حال ایجاد...',
    creatingNewLabel: 'در حال ایجاد {{label}} جدید',
    currentlyEditing:
      'کاربر دیگری در حال ویرایش این صفحه است. اگر شما ادامه دهید، ویرایش برای او متوقف شده و ممکن است تغییرات ذخیره نشده‌اش از بین برود.',
    custom: 'سفارشی',
    dark: 'تاریک',
    dashboard: 'داشبورد',
    delete: 'حذف',
    deleted: 'حذف شد',
    deletedAt: 'تاریخ حذف',
    deletedCountSuccessfully: '{{count}} {{label}} با موفقیت حذف شد.',
    deletedSuccessfully: 'با موفقیت حذف شد.',
    deleteLabel: 'حذف {{label}}',
    deletePermanently: 'حذف دائمی (خارج از سطل زباله)',
    deleting: 'در حال حذف...',
    depth: 'عمق',
    descending: 'نزولی',
    deselectAllRows: 'لغو انتخاب همه ردیف‌ها',
    document: 'صفحه',
    documentIsTrashed: 'این {{label}} به سطل زباله منتقل شده و فقط قابل خواندن است.',
    documentLocked: 'این صفحه قفل است',
    documents: 'اسناد',
    duplicate: 'ایجاد کپی',
    duplicateWithoutSaving: 'ایجاد کپی بدون ذخیره تغییرات',
    edit: 'ویرایش',
    editAll: 'ویرایش همه',
    editedSince: 'ویرایش شده از',
    editing: 'در حال ویرایش...',
    editingLabel_many: 'در حال ویرایش {{count}} {{label}}',
    editingLabel_one: 'در حال ویرایش {{count}} {{label}}',
    editingLabel_other: 'در حال ویرایش {{count}} {{label}}',
    editingTakenOver: 'کنترل ویرایش در دست شماست.',
    editLabel: 'ویرایش {{label}}',
    email: 'ایمیل',
    emailAddress: 'آدرس ایمیل',
    emptyTrash: 'خالی کردن سطل زباله',
    emptyTrashLabel: 'خالی کردن سطل زباله {{label}}',
    enterAValue: 'یک مقدار وارد کنید',
    error: 'خطا',
    errors: 'خطاها',
    exitLivePreview: 'خروج از پیش‌نمایش زنده',
    export: 'خروجی گرفتن',
    fallbackToDefaultLocale: 'استفاده از زبان پیش‌فرض',
    false: 'خیر',
    filter: 'فیلتر',
    filters: 'فیلترها',
    filterWhere: 'فیلتر کردن {{label}} بر اساس',
    globals: 'سراسری‌ها (Globals)',
    goBack: 'بازگشت',
    groupByLabel: 'گروه‌بندی بر اساس {{label}}',
    import: 'ورود اطلاعات',
    isEditing: 'در حال ویرایش است',
    item: 'مورد',
    items: 'موارد',
    language: 'زبان',
    lastModified: 'آخرین تغییر',
    leaveAnyway: 'بله، خارج شو',
    leaveWithoutSaving: 'خروج بدون ذخیره',
    light: 'روشن',
    livePreview: 'پیش‌نمایش زنده',
    loading: 'در حال بارگذاری...',
    locale: 'زبان',
    locales: 'زبان‌ها',
    menu: 'منو',
    moreOptions: 'گزینه‌های بیشتر',
    move: 'انتقال',
    moveConfirm: 'آیا از انتقال {{count}} {{label}} به <1>{{destination}}</1> مطمئن هستید؟',
    moveCount: 'انتقال {{count}} {{label}}',
    moveDown: 'انتقال به پایین',
    moveUp: 'انتقال به بالا',
    moving: 'در حال انتقال...',
    movingCount: 'در حال انتقال {{count}} {{label}}',
    newLabel: '{{label}} جدید',
    newPassword: 'رمز عبور جدید',
    next: 'بعدی',
    no: 'خیر',
    noDateSelected: 'تاریخی انتخاب نشده است',
    noFiltersSet: 'هیچ فیلتری اعمال نشده است.',
    noLabel: 'بدون {{label}}',
    none: 'هیچکدام',
    noOptions: 'گزینه‌ای وجود ندارد',
    noResults:
      'هیچ موردی برای "{{label}}" یافت نشد. یا موردی ایجاد نشده یا با فیلترهای شما مطابقت ندارد.',
    notFound: 'یافت نشد',
    nothingFound: 'موردی یافت نشد',
    noTrashResults: 'هیچ {{label}} در سطل زباله وجود ندارد.',
    noUpcomingEventsScheduled: 'رویداد آینده‌ای برنامه‌ریزی نشده است.',
    noValue: 'بدون مقدار',
    of: 'از',
    only: 'فقط',
    open: 'باز کردن',
    or: 'یا',
    order: 'ترتیب',
    overwriteExistingData: 'بازنویسی اطلاعات موجود در فیلدها',
    pageNotFound: 'صفحه پیدا نشد',
    password: 'رمز عبور',
    pasteField: 'جای‌گذاری در فیلد',
    pasteRow: 'جای‌گذاری در ردیف',
    payloadSettings: 'تنظیمات Payload',
    permanentlyDelete: 'حذف دائمی',
    permanentlyDeletedCountSuccessfully: '{{count}} {{label}} با موفقیت برای همیشه حذف شد.',
    perPage: 'تعداد در هر صفحه: {{limit}}',
    previous: 'قبلی',
    reindex: 'ایندکس مجدد',
    reindexingAll: 'در حال ایندکس مجدد همه {{collections}}...',
    remove: 'حذف',
    rename: 'تغییر نام',
    reset: 'بازنشانی',
    resetPreferences: 'بازنشانی تنظیمات شخصی',
    resetPreferencesDescription: 'این کار تمام تنظیمات شخصی شما را به حالت پیش‌فرض برمی‌گرداند.',
    resettingPreferences: 'در حال بازنشانی تنظیمات...',
    restore: 'بازیابی',
    restoreAsPublished: 'بازیابی به عنوان نسخه منتشر شده',
    restoredCountSuccessfully: '{{count}} {{label}} با موفقیت بازیابی شد.',
    restoring: 'در حال بازیابی...',
    row: 'ردیف',
    rows: 'ردیف‌ها',
    save: 'ذخیره',
    saving: 'در حال ذخیره...',
    schedulePublishFor: 'زمان‌بندی انتشار برای "{{title}}"',
    searchBy: 'جستجو بر اساس {{label}}',
    select: 'انتخاب',
    selectAll: 'انتخاب همه {{count}} {{label}}',
    selectAllRows: 'انتخاب همه ردیف‌ها',
    selectedCount: '{{count}} {{label}} انتخاب شد',
    selectLabel: 'انتخاب {{label}}',
    selectValue: 'یک مقدار انتخاب کنید',
    showAllLabel: 'نمایش همه {{label}}',
    sorryNotFound: 'متأسفانه، موردی مطابق با درخواست شما پیدا نشد.',
    sort: 'مرتب‌سازی',
    sortByLabelDirection: 'مرتب‌سازی بر اساس {{label}} {{direction}}',
    stayOnThisPage: 'در همین صفحه بمان',
    submissionSuccessful: 'با موفقیت ارسال شد.',
    submit: 'ارسال',
    submitting: 'در حال ارسال...',
    success: 'موفقیت',
    successfullyCreated: '{{label}} با موفقیت ایجاد شد.',
    successfullyDuplicated: 'کپی از {{label}} با موفقیت ایجاد شد.',
    successfullyReindexed:
      'با موفقیت {{count}} از {{total}} سند از {{collections}} بازشاخص‌گذاری شد و {{skips}} پیش‌نویس رد شد.',
    takeOver: 'ادامه ویرایش',
    thisLanguage: 'فارسی',
    time: 'زمان',
    timezone: 'منطقه زمانی',
    titleDeleted: '{{label}} "{{title}}" با موفقیت حذف شد.',
    titleRestored: '{{label}} "{{title}}" با موفقیت بازیابی شد.',
    titleTrashed: '{{label}} "{{title}}" به سطل زباله منتقل شد.',
    trash: 'سطل زباله',
    trashedCountSuccessfully: '{{count}} {{label}} به سطل زباله منتقل شد.',
    true: 'بله',
    unauthorized: 'غیرمجاز',
    unsavedChanges: 'تغییرات ذخیره نشده‌ای دارید. قبل از ادامه، آن‌ها را ذخیره یا لغو کنید.',
    unsavedChangesDuplicate:
      'شما تغییرات ذخیره نشده‌ای دارید. آیا می‌خواهید بدون ذخیره، کپی ایجاد کنید؟',
    untitled: 'بدون عنوان',
    upcomingEvents: 'رویدادهای آینده',
    updatedAt: 'تاریخ به‌روزرسانی',
    updatedCountSuccessfully: '{{count}} {{label}} با موفقیت به‌روزرسانی شد.',
    updatedLabelSuccessfully: '{{label}} با موفقیت به‌روزرسانی شد.',
    updatedSuccessfully: 'با موفقیت به‌روزرسانی شد.',
    updateForEveryone: 'به‌روزرسانی برای همه',
    updating: 'در حال به‌روزرسانی...',
    uploading: 'در حال آپلود...',
    uploadingBulk: 'در حال آپلود {{current}} از {{total}}',
    user: 'کاربر',
    username: 'نام کاربری',
    users: 'کاربران',
    value: 'مقدار',
    viewing: 'در حال مشاهده',
    viewReadOnly: 'مشاهده (فقط خواندنی)',
    welcome: 'خوش آمدید',
    yes: 'بله',
  },
  localization: {
    cannotCopySameLocale: 'امکان کپی کردن اطلاعات به همان زبان وجود ندارد.',
    copyFrom: 'کپی از',
    copyFromTo: 'کپی کردن از {{from}} به {{to}}',
    copyTo: 'کپی به',
    copyToLocale: 'کپی به زبان دیگر',
    localeToPublish: 'زبان مورد نظر برای انتشار',
    selectedLocales: 'انتخاب مناطق',
    selectLocaleToCopy: 'یک زبان برای کپی کردن اطلاعات انتخاب کنید',
    selectLocaleToDuplicate: 'انتخاب مکان‌ها برای تکثیر',
  },
  operators: {
    contains: 'شامل می‌شود',
    equals: 'برابر است با',
    exists: 'وجود دارد',
    intersects: 'اشتراک دارد',
    isGreaterThan: 'بزرگتر از',
    isGreaterThanOrEqualTo: 'بزرگتر یا مساوی با',
    isIn: 'یکی از',
    isLessThan: 'کوچکتر از',
    isLessThanOrEqualTo: 'کوچکتر یا مساوی با',
    isLike: 'مشابه',
    isNotEqualTo: 'برابر نیست با',
    isNotIn: 'هیچکدام از',
    isNotLike: 'مشابه نیست',
    near: 'نزدیک به',
    within: 'در محدوده',
  },
  upload: {
    addFile: 'افزودن فایل',
    addFiles: 'افزودن فایل‌ها',
    bulkUpload: 'آپلود گروهی',
    crop: 'برش',
    cropToolDescription:
      'گوشه‌های ناحیه انتخاب شده را بکشید، یک ناحیه جدید رسم کنید یا مقادیر زیر را تنظیم نمایید.',
    download: 'دانلود',
    dragAndDrop: 'یک فایل را اینجا بکشید و رها کنید',
    dragAndDropHere: 'یا یک فایل را اینجا بکشید و رها کنید',
    editImage: 'ویرایش تصویر',
    fileName: 'نام فایل',
    fileSize: 'حجم فایل',
    filesToUpload: 'فایل‌ها برای آپلود',
    fileToUpload: 'فایل برای آپلود',
    focalPoint: 'نقطه کانونی',
    focalPointDescription: 'نقطه کانونی را مستقیماً روی تصویر بکشید یا مقادیر زیر را تنظیم کنید.',
    height: 'ارتفاع',
    lessInfo: 'اطلاعات کمتر',
    moreInfo: 'اطلاعات بیشتر',
    noFile: 'فایلی وجود ندارد',
    pasteURL: 'جای‌گذاری URL',
    previewSizes: 'اندازه‌های پیش‌نمایش',
    selectCollectionToBrowse: 'یک مجموعه را برای مرور انتخاب کنید',
    selectFile: 'انتخاب فایل',
    setCropArea: 'تنظیم ناحیه برش',
    setFocalPoint: 'تنظیم نقطه کانونی',
    sizes: 'اندازه‌ها',
    sizesFor: 'اندازه‌ها برای {{label}}',
    width: 'عرض',
  },
  validation: {
    emailAddress: 'لطفاً یک آدرس ایمیل معتبر وارد کنید.',
    enterNumber: 'لطفاً یک عدد معتبر وارد کنید.',
    fieldHasNo: 'این فیلد نباید حاوی هیچ {{label}} باشد.',
    greaterThanMax: 'مقدار وارد شده ({{value}}) نباید بیشتر از {{max}} باشد.',
    invalidBlock: 'بلاک "{{block}}" در این فیلد مجاز نیست.',
    invalidBlocks: 'این فیلد حاوی بلاک‌های غیرمجاز است: {{blocks}}',
    invalidInput: 'مقدار وارد شده نامعتبر است.',
    invalidSelection: 'گزینه انتخاب شده نامعتبر است.',
    invalidSelections: 'این فیلد حاوی گزینه‌های نامعتبر است:',
    latitudeOutOfBounds: 'عرض جغرافیایی باید بین -90 تا 90 باشد.',
    lessThanMin: 'مقدار وارد شده ({{value}}) نباید کمتر از {{min}} باشد.',
    limitReached: 'حداکثر تعداد مجاز {{max}} مورد است و شما نمی‌توانید موارد بیشتری اضافه کنید.',
    longerThanMin: 'طول متن باید بیشتر از {{minLength}} کاراکتر باشد.',
    longitudeOutOfBounds: 'عرض جغرافیایی باید بین -180 و 180 باشد.',
    notValidDate: '"{{value}}" یک تاریخ معتبر نیست.',
    required: 'این فیلد الزامی است.',
    requiresAtLeast: 'این فیلد به حداقل {{count}} {{label}} نیاز دارد.',
    requiresNoMoreThan: 'این فیلد نمی‌تواند بیشتر از {{count}} {{label}} داشته باشد.',
    requiresTwoNumbers: 'این فیلد به دو عدد نیاز دارد.',
    shorterThanMax: 'طول متن باید کمتر از {{maxLength}} کاراکتر باشد.',
    timezoneRequired: 'انتخاب منطقه زمانی الزامی است.',
    trueOrFalse: 'مقدار این فیلد فقط می‌تواند "true" یا "false" باشد.',
    username:
      'لطفاً یک نام کاربری معتبر وارد کنید. فقط حروف، اعداد، نقطه، خط تیره و زیرخط مجاز هستند.',
    validUploadID: 'شناسه آپلود معتبر نیست.',
  },
  version: {
    type: 'نوع',
    aboutToPublishSelection: 'آیا از انتشار تمام {{label}} انتخاب شده مطمئن هستید؟',
    aboutToRestore:
      'شما در حال بازگردانی این {{label}} به نسخه‌ای هستید که در تاریخ {{versionDate}} ذخیره شده است. آیا ادامه می‌دهید؟',
    aboutToRestoreGlobal:
      'شما در حال بازگردانی {{label}} به نسخه مربوط به تاریخ {{versionDate}} هستید. آیا ادامه می‌دهید؟',
    aboutToRevertToPublished:
      'شما در حال بازگرداندن این صفحه به آخرین نسخه منتشر شده آن هستید. آیا مطمئن هستید؟',
    aboutToUnpublish: 'آیا از لغو انتشار این صفحه مطمئن هستید؟',
    aboutToUnpublishSelection: 'آیا از لغو انتشار {{label}} انتخاب شده مطمئن هستید؟',
    autosave: 'ذخیره خودکار',
    autosavedSuccessfully: 'با موفقیت به صورت خودکار ذخیره شد.',
    autosavedVersion: 'نسخه ذخیره خودکار',
    changed: 'تغییر کرده',
    changedFieldsCount_one: '{{count}} فیلد تغییر کرد',
    changedFieldsCount_other: '{{count}} فیلد تغییر کرد',
    compareVersion: 'مقایسه با نسخه:',
    compareVersions: 'مقایسه نسخه‌ها',
    comparingAgainst: 'مقایسه با',
    confirmPublish: 'تأیید انتشار',
    confirmRevertToSaved: 'تأیید بازگردانی به نسخه ذخیره شده',
    confirmUnpublish: 'تأیید لغو انتشار',
    confirmVersionRestoration: 'تأیید بازیابی نسخه',
    currentDocumentStatus: 'وضعیت فعلی صفحه: {{docStatus}}',
    currentDraft: 'پیش‌نویس فعلی',
    currentlyPublished: 'منتشر شده',
    currentlyViewing: 'در حال مشاهده',
    currentPublishedVersion: 'آخرین نسخه منتشر شده',
    draft: 'پیش‌نویس',
    draftHasPublishedVersion: 'پیش‌نویس (نسخه منتشر شده دارد)',
    draftSavedSuccessfully: 'پیش‌نویس با موفقیت ذخیره شد.',
    lastSavedAgo: 'آخرین ذخیره {{distance}} پیش',
    modifiedOnly: 'فقط موارد تغییر کرده',
    moreVersions: 'نسخه‌های بیشتر...',
    noFurtherVersionsFound: 'نسخه دیگری پیدا نشد.',
    noLabelGroup: 'گروه بدون نام',
    noRowsFound: 'هیچ {{label}} یافت نشد.',
    noRowsSelected: 'هیچ {{label}} انتخاب نشده است.',
    preview: 'پیش‌نمایش',
    previouslyDraft: 'قبلاً پیش‌نویس بوده',
    previouslyPublished: 'قبلاً منتشر شده',
    previousVersion: 'نسخه قبلی',
    problemRestoringVersion: 'در بازیابی این نسخه مشکلی پیش آمد.',
    publish: 'انتشار',
    publishAllLocales: 'انتشار در تمام زبان‌ها',
    publishChanges: 'انتشار تغییرات',
    published: 'منتشر شده',
    publishIn: 'انتشار در زبان {{locale}}',
    publishing: 'در حال انتشار...',
    restoreAsDraft: 'بازیابی به عنوان پیش‌نویس',
    restoredSuccessfully: 'با موفقیت بازیابی شد.',
    restoreThisVersion: 'بازیابی این نسخه',
    restoring: 'در حال بازیابی...',
    reverting: 'در حال بازگردانی...',
    revertToPublished: 'بازگردانی به نسخه منتشر شده',
    saveDraft: 'ذخیره پیش‌نویس',
    scheduledSuccessfully: 'با موفقیت زمان‌بندی شد.',
    schedulePublish: 'زمان‌بندی انتشار',
    selectLocales: 'زبان‌ها را برای نمایش انتخاب کنید',
    selectVersionToCompare: 'یک نسخه را برای مقایسه انتخاب کنید',
    showingVersionsFor: 'نمایش نسخه‌ها برای:',
    showLocales: 'نمایش زبان‌ها:',
    specificVersion: 'نسخه مشخص',
    status: 'وضعیت',
    unpublish: 'لغو انتشار',
    unpublishing: 'در حال لغو انتشار...',
    version: 'نسخه',
    versionAgo: '{{distance}} پیش',
    versionCount_many: '{{count}} نسخه پیدا شد',
    versionCount_none: 'هیچ نسخه‌ای پیدا نشد',
    versionCount_one: '{{count}} نسخه پیدا شد',
    versionCount_other: '{{count}} نسخه پیدا شد',
    versionID: 'شناسه نسخه',
    versions: 'نسخه‌ها',
    viewingVersion: 'مشاهده نسخه برای {{entityLabel}} "{{documentTitle}}"',
    viewingVersionGlobal: 'مشاهده نسخه‌های کلی برای {{entityLabel}}',
    viewingVersions: 'مشاهده نسخه‌ها برای {{entityLabel}} "{{documentTitle}}"',
    viewingVersionsGlobal: 'مشاهده نسخه‌های کلی برای {{entityLabel}}',
  },
}

export const fa: Language = {
  dateFNSKey: 'fa-IR',
  translations: faTranslations,
}
